import React from 'react';
import ReactDOM from 'react-dom';
import { Router, Route, browserHistory, IndexRoute, hashHistory } from 'react-router';
import Main from './app/screens/Main';
import Home from './app/screens/Home';
import About from './app/screens/About';
import Description from './app/screens/About/description.js';
import Media from './app/screens/About/media.js';
import Projects from './app/screens/Projects/projects.js';
import FutureProjects from './app/screens/Projects/futureprojects.js'
import Center from './app/screens/Center/center.js'
import Christmas from './app/screens/Christmas/christmas.js'
import Donate from './app/screens/Donate/donate.js'
import Contact from './app/screens/Contact/contact.js'

import 'bootstrap/dist/css/bootstrap.min.css';
import './assets/styles.css';

ReactDOM.render(
  <Router history={browserHistory}>
    <Route path="/" component={Main}>
      {/* <IndexRoute component={Main} /> */}
      <Route path="main" component={Main} />
      <Route path="home" component={Home} />
      <Route path="about" component={About} />
      <Route path="description" component={Description} />
      <Route path="media" component={Media} />
      <Route path="projects" component={Projects} />
      <Route path="futureprojects" component={FutureProjects} />
      <Route path="center" component={Center} />
      <Route path="christmas" component={Christmas} />
      <Route path="donate" component={Donate} />
      <Route path="contact" component={Contact} />    
    </Route>
  </Router>,
  document.getElementById('container')
);



// WEBPACK FOOTER //
// ./index.js